import { Validator } from "@quotientjs/browser-storage"

/**
 * String validator that ensures the value is a string
 */
export const stringValidator: Validator<string> = {
  parse: (val: unknown): string => {
    if (typeof val === "string") {
      return val
    }
    throw new Error(`Expected string, got ${typeof val}`)
  },
  safeParse: (val: unknown) => {
    if (typeof val === "string") {
      return { success: true, data: val }
    }
    return {
      success: false,
      error: new Error(`Expected string, got ${typeof val}`),
    }
  },
}
